export default __webpack_public_path__ + "static/media/workshop3.358af59f.jpg";